import Admin from './content';
import AdminNavigation from './navigation';

export { Admin, AdminNavigation };



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js